__turbopack_context__.v({
  "checkboxContainer": "LoginView-module__oma4Aa__checkboxContainer",
  "checkboxInput": "LoginView-module__oma4Aa__checkboxInput",
  "desktopTopActions": "LoginView-module__oma4Aa__desktopTopActions",
  "desktopTopLeftActions": "LoginView-module__oma4Aa__desktopTopLeftActions",
  "elieContainer": "LoginView-module__oma4Aa__elieContainer",
  "elieImg": "LoginView-module__oma4Aa__elieImg",
  "errorBanner": "LoginView-module__oma4Aa__errorBanner",
  "eyeToggleBtn": "LoginView-module__oma4Aa__eyeToggleBtn",
  "floatingElieAvatarDesktop": "LoginView-module__oma4Aa__floatingElieAvatarDesktop",
  "floatingSupportMobile": "LoginView-module__oma4Aa__floatingSupportMobile",
  "floatingWhatsappDesktop": "LoginView-module__oma4Aa__floatingWhatsappDesktop",
  "formContainer": "LoginView-module__oma4Aa__formContainer",
  "formFooter": "LoginView-module__oma4Aa__formFooter",
  "formWrapper": "LoginView-module__oma4Aa__formWrapper",
  "highlightMarker": "LoginView-module__oma4Aa__highlightMarker",
  "highlightSvg": "LoginView-module__oma4Aa__highlightSvg",
  "inputError": "LoginView-module__oma4Aa__inputError",
  "inputField": "LoginView-module__oma4Aa__inputField",
  "inputIcon": "LoginView-module__oma4Aa__inputIcon",
  "inputWrapper": "LoginView-module__oma4Aa__inputWrapper",
  "leftColumn": "LoginView-module__oma4Aa__leftColumn",
  "logoContainer": "LoginView-module__oma4Aa__logoContainer",
  "mainCanvas": "LoginView-module__oma4Aa__mainCanvas",
  "mobileHeader": "LoginView-module__oma4Aa__mobileHeader",
  "mobileLangBtn": "LoginView-module__oma4Aa__mobileLangBtn",
  "mobileLangFlag": "LoginView-module__oma4Aa__mobileLangFlag",
  "mobileRegisterBtn": "LoginView-module__oma4Aa__mobileRegisterBtn",
  "mobileScrollSpacer": "LoginView-module__oma4Aa__mobileScrollSpacer",
  "mobileSocialBar": "LoginView-module__oma4Aa__mobileSocialBar",
  "mobileSocialBtn": "LoginView-module__oma4Aa__mobileSocialBtn",
  "pageWrapper": "LoginView-module__oma4Aa__pageWrapper",
  "registerLink": "LoginView-module__oma4Aa__registerLink",
  "rightCard": "LoginView-module__oma4Aa__rightCard",
  "socialContainer": "LoginView-module__oma4Aa__socialContainer",
  "submitBtn": "LoginView-module__oma4Aa__submitBtn",
  "subtitle": "LoginView-module__oma4Aa__subtitle",
  "title": "LoginView-module__oma4Aa__title",
  "topActionBtn": "LoginView-module__oma4Aa__topActionBtn",
  "waGlowBtn": "LoginView-module__oma4Aa__waGlowBtn",
  "waPulseGlow": "LoginView-module__oma4Aa__waPulseGlow",
  "waRadarPing": "LoginView-module__oma4Aa__waRadarPing",
  "waRadarRing": "LoginView-module__oma4Aa__waRadarRing",
  "waRadarRingDelayed": "LoginView-module__oma4Aa__waRadarRingDelayed",
});
